<template>
  <div class="home-container">
    <div class="header-banner">
      <div class="bt banner-bt" style="margin-top:50px" @click="handleClickUserapply">立即试用</div>
      <swiper
        ref="mySwiper"
        autoplay="3000"
        :options="swiperOptions"
      >
        <swiper-slide v-for="item in bannerOptions" :key="item.src">
          <img class="img" :src="item.src" />
          <div class="tip-container">
            <div class="text1">{{ item.text1 }}</div>
            <div class="text2">{{ item.text2 }}</div>
          </div>
        </swiper-slide>
        <div id="swiper-pagination" class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="content-item scrm">
      <div class="content" :style="{textAlign: 'center'}">
        <CustomTitle title="产品与服务" en-title="product" />
        <div class="scrm-container">
          <div v-for="option in scrmOptions" :key="option.text1" class="scrm-item">
            <img class="img" :src="option.src" />
            <div class="text-container">
              <div class="text1">{{option.text1}}</div>
              <div class="text2">{{option.text2}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item operation">
      <CustomTitle
        title="用户运营全链路解决方案"
        en-title="User operation"
        sub-title="创建全链路用户激活机制，提升用户全生命周期的服务体验，促进转化效率"
      />
      <div class="user-operation-container">
        <div class="bt" style="margin-top:64px" @click="handleClickUserapply">立即试用</div>
        <img class="img" src="@/assets/用户运营全链路解决方案.png" />
      </div>
    </div>
    <div class="content-item operation2">
      <CustomTitle
        title="高频活跃的全场景运营服务阵地"
        sub-title="超级APP体系+专业的运营策略，助力企业与用户构建全场景的高频触达连接"
      />
      <div class="user-operation-container">
        <img class="img2" src="@/assets/高频活跃的全场景运营服务阵地1.png" />
        <img class="mobile-img" src="@/assets/mobile-高频活跃.png" />
      </div>
    </div>
    <div class="content-item scrm2">
      <div class="content" :style="{textAlign: 'center'}">
        <CustomTitle
          title="企微助手SCRM"
          en-title="Social Customer Relationship Management"
          sub-title="搭建全渠道用户私域流量池，多触点激活用户价值，实现自动化营销闭环"
        />
        <div class="scrm-helper-container">
          <div class="bt" style="margin-top:40px" @click="handleClickUserapply">立即试用</div>
          <div class="box-item-container">
            <div v-for="(option, index) in scrmHelperOptions" :key="index" class="big-item" :class="{ 'two-big-item' : option.length === 2 }">
              <div
                v-for="(item, itemIndex) in option"
                :key="itemIndex"
                class="item"
                :class="{ 'center-item' : index === 2, 'hover-item': item.index === hoverIndex }"
                @mouseenter="scrmItemMouseenterleave('enter', item)"
                @mouseleave="scrmItemMouseenterleave('leave', item)"
              >
                <img class="img" :src="item.src" alt="" />
                <div v-if="item.text" class="text">{{item.text}}</div>
              </div>
            </div>
          </div>
          <div class="text-item-container">
            <div class="big-item" v-for="(option, index) in scrmHelperTextOptions" :key="option.title">
              <div
                class="item"
                :class="{ 'hover-item': index === hoverIndex }"
                @mouseenter="scrmItemMouseenterleave('enter', option)"
                @mouseleave="scrmItemMouseenterleave('leave', option)"
              >
                <div class="title-container">
                  <div class="title">{{option.title}}</div>
                  <!-- <div class="sub-title">{{option.subTitle}}</div> -->
                </div>
                <div class="desc">{{option.subTitle}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <CustomTitle
          title="使用场景"
        />
        <img style="width:1200px;height:220px;margin-top:20px" src="@/assets/使用场景.png" /> -->
      </div>
    </div>
    <div class="content-item table-power">
      <div class="table-power-container">
        <div class="header">
          <!-- <img style="width:1140px;height:112px;" src="@/assets/表格头部切图.png" /> -->
          <div class="title">智域能力矩阵</div>
          <div class="sub-title">多年0到1产品实战，用户运营能力沉淀</div>
        </div>
        <table class="table">
          <tbody>
            <tr v-for="(items, index) in tableOption" :key="index">
              <td v-for="(item, itemIndex) in items" :key="itemIndex">
                <div class="title">{{ item.title }}</div>
                <div class="desc" v-html="item.desc" />
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table2">
          <tbody>
            <tr v-for="(items, index) in tableOption2" :key="index">
              <td v-for="(item, itemIndex) in items" :key="itemIndex">
                <div class="title">{{ item.title }}</div>
                <div class="desc" v-html="item.desc" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="bannner-fotter-container">
      <div class="bg">
        <div class="title">一键开启你的私域数字化转型之旅</div>
        <div class="bt" style="margin-top:40px" @click="handleClickUserapply">申请试用</div>
      </div>
    </div>
    <FooterBottom />
    <div class="footer-bt">
      <div class="bt" @click="handleClickUserapply">立即使用</div>
    </div>
    <Userapply ref="Userapply" />
    <div v-if="showMenu" class="right-menu-container">
      <div class="rqcode-container">
        <img src="@/assets/qrcode-small.png" alt="" />
        <div class="user-apply-container">
          <img class="rqcode" src="@/assets/qrcode.png" alt="" />
          <div class="text">立即试用</div>
        </div>
      </div>
      <img class="upTop" src="@/assets/up-top.png" alt="" @click="handleClickupTop" />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import CustomTitle from '@/components/CustomTitle'
import Userapply from './Userapply'
import FooterBottom from './FooterBottom'

export default {
  components: {
    Swiper,
    SwiperSlide,
    CustomTitle,
    FooterBottom,
    Userapply
  },
  props: {
    a: {
      type: [String, Number]
    }
  },
  data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bullet-class',
          bulletActiveClass: 'bullet-active-class',
          clickable: true
        },
        // 自动轮播
        autoplay: {
          delay: 3000,
          // 当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        // 开启循环模式
        loop: true
      },
      bannerOptions: [
        {
          src: require('../../assets/swiper1.png'),
          text1: '智域·私域流量运营专家',
          text2: '促进潜客转化，提升保客粘性'
        },
        {
          src: require('../../assets/swiper2.png'),
          text1: '购车前预见你的客户',
          text2: '用户画像提前知晓，服务邀约一键开启'
        },
        {
          src: require('../../assets/swiper3.png'),
          text1: '卖车时销售更精准',
          text2: '按需提供销售服务，互动信息全程留存'
        },
        {
          src: require('../../assets/swiper4.png'),
          text1: '用车后无忧体验',
          text2: '售后保养及时提醒，快速解决用车所需'
        }
      ],
      scrmOptions: [
        {
          text1: '用户运营平台',
          text2: '通过相应运营方法和促活机制，提升用户活跃度和粘性，与用户建立多频高效的互动连接',
          src: require('../../assets/SCRM1.png')
        },
        {
          text1: '企微助手SCRM',
          text2: '聚客于企业微信端，构建私域流量池最大化引流获客，提升商机转化，促进续约复购',
          src: require('../../assets/SCRM2.png')
        },
        {
          text1: '运营策略及服务',
          text2: '提供社群、活动、商城等完备运营形式下的策略指导，构建全场景运营服务阵地，提供全方位代运营服务',
          src: require('../../assets/SCRM3.png')
        }
      ],
      scrmHelperOptions: [
        [
          {
            index: 1,
            text: '拉新裂变获客',
            src: require('../../assets/拉新裂变获客.png')
          }
        ],
        [
          {
            index: 0,
            text: '私域流量沉淀',
            src: require('../../assets/私域流量沉淀.png')
          },
          {
            index: 2,
            text: '企业微信体系',
            src: require('../../assets/企业微信体系.png')
          }
        ],
        [
          {
            index: -2,
            text: '',
            src: require('../../assets/scrm-helper-center.png')
          }
        ],
        [
          {
            index: 3,
            text: '会话存档',
            src: require('../../assets/会话存档.png')
          },
          {
            index: 5,
            text: '多维度客户分析',
            src: require('../../assets/多维度客户分析.png')
          }
        ],
        [
          {
            index: 4,
            text: '自动化营销',
            src: require('../../assets/自动化营销.png')
          }
        ]
      ],
      hoverIndex: -1,
      scrmHelperTextOptions: [
        {
          index: 0,
          title: '私域流量沉淀',
          subTitle: '一站式私域流量运营平台',
          desc: '打通销售售后全流程 | 拉新>沉淀>转化>再激活'
        },
        {
          index: 1,
          title: '拉新裂变获客',
          subTitle: '多渠道引流获客',
          desc: '任务宝 | 抽奖裂变 | 红包裂变｜营销活动 | 员工红包 | 裂变海报'
        },
        {
          index: 2,
          title: '企业微信体系',
          subTitle: '高效沟通客户促转化',
          desc: '渠道活码 | 粉丝会话 | 话术素材｜社群管理 | 员工红包 | 裂变海报'
        },
        {
          index: 3,
          title: '会话存档',
          subTitle: '企业风控质检有保障',
          desc: '聊天内容合规存档 | 违规关键词提醒 | 客户流失提醒 | 员工、客户聊天统计 | 群聊统计 | 防群骚扰'
        },
        {
          index: 4,
          title: '自动化营销',
          subTitle: '围绕用户生命周期模型',
          desc: '欢迎语 | 自动回复 | 自动提醒｜SOP标准化推送 | 服务代办事项 | 群发消息'
        },
        {
          index: 5,
          title: '多维度客户分析',
          subTitle: '帮助企业实现数据驱动商业',
          desc: '客户CRM体系 | 客户群管理 | 用户RFM画像｜用户群画像 | 用户会员成长体系 | 用户分层'
        }
      ],
      tableOption: [
        [
          {
            title: '流量/渠道运营',
            desc: '渠道扩张、平台引流'
          },
          {
            title: '用户运营',
            desc: '精准识别核心用户'
          },
          {
            title: '内容运营',
            desc: '定制化内容策略'
          },
          {
            title: '商城运营',
            desc: '选品策略、营销策略'
          }
        ],
        [
          {
            title: '积分运营',
            desc: '积分策略、用户分层'
          },
          {
            title: '活动运营',
            desc: '活动定制、活动策划'
          },
          {
            title: '产品开发能力',
            desc: '头部新势力产品团队<br />创新产品技术开发'
          },
          {
            title: '交互设计能力',
            desc: '高质量用户体验<br />系统化设计思维'
          }
        ],
        [
          {
            title: '应用研发能力',
            desc: '70%研发人员占比<br />算法开发能力，数十项技术专利'
          },
          {
            title: '全局策略能力',
            desc: '多年用户运营实操'
          },
          {
            title: '数据领先能力',
            desc: '12年汽车行业积累<br />108类标准，3大saas平台'
          },
          {
            title: '服务保障能力',
            desc: '专业顾问跟进、无忧服务保障'
          }
        ]
      ],
      tableOption2: [
        [
          {
            title: '流量/渠道运营',
            desc: '渠道扩张、平台引流'
          },
          {
            title: '用户运营',
            desc: '精准识别核心用户'
          },
          {
            title: '内容运营',
            desc: '定制化内容策略'
          }
        ],
        [
          {
            title: '商城运营',
            desc: '选品策略、营销策略'
          },
          {
            title: '积分运营',
            desc: '积分策略、用户分层'
          },
          {
            title: '活动运营',
            desc: '活动定制、活动策划'
          }
        ],
        [
          {
            title: '产品开发能力',
            desc: '头部新势力产品团队<br />创新产品技术开发'
          },
          {
            title: '交互设计能力',
            desc: '高质量用户体验<br />系统化设计思维'
          },
          {
            title: '应用研发能力',
            desc: '70%研发人员占比<br />算法开发能力，数十项技术专利'
          }
        ],
        [
          {
            title: '全局策略能力',
            desc: '多年用户运营实操'
          },
          {
            title: '数据领先能力',
            desc: '12年汽车行业积累<br />108类标准，3大saas平台'
          },
          {
            title: '服务保障能力',
            desc: '专业顾问跟进、无忧服务保障'
          }
        ]
      ],
      showMenu: false
    }
  },
  computed: {
  },
  mounted () {
    window.addEventListener('scroll', this.listennerScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.listennerScroll)
  },
  methods: {
    scrmItemMouseenterleave (type, { index }) {
      if (type === 'enter') {
        this.hoverIndex = index
      } else this.hoverIndex = -1
      // console.log('scrmItemMouseenterleave', type, this.hoverIndex)
    },
    handleClickUserapply () {
      this.$refs.Userapply.show()
    },
    handleClickupTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    listennerScroll () {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.showMenu = scrollTop > window.innerHeight
      // console.log(scrollTop, window.innerHeight)
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  .content-item {
    text-align: center;
  }
  .content {
    width: 1220px;
    display: inline-block;
  }
  @media screen and (max-width: 1024px) {
    .content {
      width: auto;
      display: block;
    }
  }
  .bt {
    display: inline-block;
    width: 120px;
    height: 40px;
    background: #2F6AFF;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 40px;
    font-weight: 400;
    cursor: pointer;
    &:active {
      opacity: 0.8;
    }
    &:hover {
      background-color: #4F95FF;
    }
  }
  .header-banner {
    cursor: pointer;
    position: relative;
    .img {
      width: calc(100vw);
      height: calc(100vw * 1080 / 1920);
    }
    /deep/ .bullet-class {
      display: inline-block;
      margin-right: 8px;
      margin-bottom: 30px;
      width: 66px;
      height: 4px;
      opacity: 0.4;
      background: #FFFFFF;
    }
    /deep/ .bullet-active-class {
      opacity: 1;
      background: #FFFFFF;
    }
    .banner-bt {
      z-index: 99;
      position: absolute;
      left: 50%;
      top: 266px;
      transform: translateX(-50%);
    }
    .tip-container {
      z-index: 99;
      position: absolute;
      left: 50%;
      top: 130px;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .text1 {
        font-family: PingFangSC-Semibold;
        font-size: 48px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 600;
      }
      .text2 {
        margin-top: 24px;
        opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        font-weight: 400;
      }
    }
    @media screen and (max-width: 1024px) {
      .banner-bt {
        display: none;
      }
      .tip-container {
        align-items: flex-start;
        justify-items: flex-start;
        top: 50% !important;
        left: 32px !important;
        transform: translateY(-50%) !important;
        .text1 {
          font-size: 16px !important;
        }
        .text2 {
          margin-top: 12px !important;
          font-size: 12px !important;
        }
      }
      /deep/ .bullet-class {
        margin-bottom: 0px;
        width: 10px;
        height: 2px;
      }
    }
  }
  .scrm {
    background: #F8F8FA;
    padding: 60px 0;
  }
  .scrm-container {
    margin-top: 40px;
    display: flex;
    align-items: center;
    .scrm-item {
      margin-right: 60px;
      height: 366px;
      width: calc(100% - 120px);
      background: #FFFFFF;
      box-shadow: 0px 6px 24px 0px rgba(14,43,87,0.06);
      border-radius: 4px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 60px;
      .img {
        width: 150px;
        height: 150px;
      }
      .text-container {
        .text1 {
          margin-top: 24px;
          font-family: PingFangSC-Semibold;
          font-size: 24px;
          color: #161823;
          text-align: center;
          line-height: 26px;
          font-weight: 600;
          white-space: nowrap;
        }
        .text2 {
          margin-top: 24px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          text-align: center;
          font-weight: 400;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .scrm {
      padding: 20px 0;
    }
    .scrm-container {
      margin-top: 20px;
      padding: 0 12px;
      flex-direction: row;
      flex-wrap: wrap;
      .scrm-item {
        padding:  12px 16px;
        margin-right: 0;
        margin-top: 16px;
        height: auto;
        text-align: left;
        flex-direction: row;
        width: 100%;
        justify-content: flex-start;
        &:first-child {
          margin-top: 0;
        }
        .img {
          width: 75px;
          height: 75px;
        }
        .text-container {
          margin-left: 12px;
          .text1 {
            margin-top: 0;
            text-align: left;
            font-size: 15px;
            color: #161823;
            font-weight: 600;
          }
          .text2 {
            margin-top: 12px;
            text-align: left;
            font-size: 12px;
          }
        }
      }
    }
  }
  .scrm2 {
    padding: 50px 0 0;
    background-image: linear-gradient(180deg, #FFFFFF 0%, #F3F5FC 100%);
  }
  .scrm-helper-container {
    text-align: center;
    padding-bottom: 40px;
    .bt {
      width: 180px;
    }
    .box-item-container {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      .big-item {
        height: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .two-big-item {
        justify-content: space-between;
      }
      .item {
        transition: transform 0.3s;
        &:hover {
          transform: translateY(-10px) scale(1.1);
        }
        .img {
          width: 180px;
          height: 184px;
        }
        .text {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #2F6AFF;
          text-align: center;
          font-weight: 400;
        }
      }
      .hover-item {
        transform: translateY(-10px) scale(1.1);
      }
      .center-item {
        &:hover {
          transform: none;
        }
        .img {
          width: 456px;
          height: 480px;
        }
      }
    }
    .text-item-container {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .big-item {
        width: 33.33333333%;
        .item {
          height: 64px;
          background: #FFFFFF;
          border-radius: 4px;
          padding: 16px;
          margin: 10px;
          .title-container {
            display: flex;
            align-items: center;
            .title {
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #2F6AFF;
              line-height: 26px;
              font-weight: 600;
            }
            .sub-title {
              margin-left: 6px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #161823;
              font-weight: 400;
            }
          }
          .desc {
            text-align: left;
            margin-top: 6px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #161823;
            font-weight: 400;
          }
        }
      }
      .hover-item {
        transition: transform 0.3s;
        transform: translateY(-10px);
        border: 1px solid #2F6AFF;
        box-shadow: 0px 6px 24px 0px rgba(14,43,87,0.06);
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .scrm-helper-container {
      padding-bottom: 26px;
    }
    .scrm2 {
      padding: 25px 0 0;
      .bt {
        display: none;
      }
      .box-item-container {
        margin-top: 16px;
        .big-item {
          height: auto;
        }
        .item {
          margin-top: 20px;
          &:first-child {
            margin-top: 0;
          }
          .img {
            width: 54px;
            height: 55px;
          }
          .text {
            font-size: 12px;
          }
        }
        .center-item {
          .img {
            width: 137px;
            height: 144px;
          }
        }
      }
      .text-item-container {
        padding: 0 8px;
        margin-top: 16px;
        .big-item {
          width: 50%;
          .item {
            padding: 8px;
            margin: 4px;
            height: 53px;
            .title-container {
              .title {
                font-size: 12px;
              }
            }
            .desc {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
  .operation {
    padding: 40px 0;
  }
  .operation2 {
    padding: 50px 0 26px;
    background: #F8F8FA;
  }
  .user-operation-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .bt {
      width: 180px;
    }
    .img {
      width:1144px;
      height:474px;
      margin-top:24px
    }
    .img2 {
      width:1128px;
      height:640px;
      margin-top:10px
    }
    .mobile-img {
      display: none;
    }
  }
  @media screen and (max-width: 1024px) {
    .operation2 {
      padding-top: 25px;
    }
    .user-operation-container {
      padding: 0 12px;
      .bt {
        display: none;
      }
      .img {
        margin-top: 10px;
        width: calc(100vw - 24px);
        height: calc((100vw - 24px) * 346 / 702);
      }
      .img2 {
        display: none;
      }
      .mobile-img {
        display: block;
        margin-top: 10px;
        width: calc(100vw - 24px);
        height: calc((100vw - 24px) * 638 / 710);
      }
    }
  }
  .table-power {
    padding: 40px 0;
    background: #fff;
  }
  .table-power-container {
    display: inline-block;
    .header {
      display: flex;
      align-items: center;
      width: 1140px;
      height: 112px;
      background-color: #2F6AFF;
      .title {
        margin-left: 24px;
        font-family: PingFangSC-Semibold;
        font-size: 36px;
        color: #FFFFFF;
        font-weight: 600;
      }
      .sub-title {
        margin-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        font-weight: 400;
      }
    }
    .table2 {
      display: none;
    }
    .table, .table2 {
      width: 1140px;
      border-spacing: 0;
      tr {
        td:first-child {
          border-left: 1px solid #E1E1E1;
        }
      }
      td {
        vertical-align: top;
        width: 25%;
        // border: 1px solid #E1E1E1;
        border-right: 1px solid #E1E1E1;
        border-bottom: 1px solid #E1E1E1;
        padding: 30px 24px 35px 24px;
      }
      .title {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #2F6AFF;
        text-align: justify;
        font-weight: 400;
      }
      .desc {
        margin-top: 14px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #161823;
        text-align: justify;
        font-weight: 400;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .table-power {
      padding: 20px 0;
    }
    .table-power-container {
      padding: 0 12px;
      display: block;
      .header {
        justify-content: center;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        height: 65px;
        .title {
          margin-left: 12px;
          font-size: 14px;
        }
        .sub-title {
          margin-top: 6px;
          margin-left: 12px;
          font-size: 10px;
        }
      }
      .table {
        display: none;
      }
      .table2 {
        display: table;
        width: 100%;
        border-spacing: 0;
        td {
          width: 33.33333333%;
          // border: 1px solid #E1E1E1;
          border-right: 1px solid #E1E1E1;
          border-bottom: 1px solid #E1E1E1;
          padding: 25px 9px 13px 8px;
        }
        .title {
          font-size: 12px;
        }
        .desc {
          margin-top: 8px;
          font-size: 9px;
        }
      }
    }
  }
  .bannner-fotter-container {
    background-image: linear-gradient(to right, #0091E7, #60BBFF);
    .bg {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 320px;
      background: url('../../assets/banner-fotter.png') no-repeat center;
    }
    .bt {
      width: 180px;
    }
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 44px;
      color: #FFFFFF;
      text-align: center;
      font-weight: 600;
    }
  }
  @media screen and (max-width: 1024px) {
    .bannner-fotter-container {
      display: none;
    }
  }
  .right-menu-container {
    position: fixed;
    z-index: 999999;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
      display: block;
    }
    .upTop {
      cursor: pointer;
    }
    .rqcode-container {
      position: relative;
      &:hover {
        .user-apply-container {
          display: flex;
        }
      }
      .user-apply-container {
        position: absolute;
        z-index: 999999;
        padding: 16px;
        display: none;
        flex-direction: column;
        align-items: center;
        right: 60px;
        top: -46px;
        background: #fff;
        .rqcode {
          width: 98px;
          height: 98px;
        }
        .text {
          margin-top: 10px;
          font-family: PingFangSC-Regular;
          font-size: 10px;
          color: #171920;
          text-align: center;
          line-height: 10px;
          font-weight: 400;
        }
      }
    }
  }
  .footer-bt {
    display: none;
    position: fixed;
    z-index: 9999;
    background-color: #fff;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 12px;
    .bt {
      display:block;
      width: auto;
      height: 44px;
    }
  }
  @media screen and (max-width: 1024px) {
    .footer-bt {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue